import Button from "@/common/components/Button"
import { GeoTransformers } from "@/common/services/geoTransformers"
import { HolidayData } from "@/common/types/holidays"
import { formatDateInLocalTimezone } from "@/common/utils/formatters"
import { geoIdentifyTypeByObject } from "@/common/utils/geoUtils"
import { ArrowBigRight } from "lucide-react"
import { Link } from "react-router-dom"

export class HolidaysTransformer {
  static tableTransformer() {
    return (holidays: HolidayData[]) => {
      return holidays.map((holiday) => {
        const regionFormatted = GeoTransformers.geoItemTransformer({
          geo: holiday.geo,
          geo_type: geoIdentifyTypeByObject(holiday.geo)
        })

        return {
          ...holiday,
          region: regionFormatted?.label,
          date: formatDateInLocalTimezone(holiday.date),
          actions: (
            <Link to={`/holidays/${holiday.id}`}>
              <Button className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission="Admin::Calendar::Holidays::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        }
      })
    }
  }
}
